import { SortableElement } from "react-sortable-hoc";

import Collaborator from "./Collaborator";

export default SortableElement(Collaborator);
